import Headroom from 'headroom.js';

export const stickyHeader = {
  mounted(el) {
    new Headroom(el).init();
  },
};
